<template><!-- svgo-optimised -->
<svg class="icon icon__layout-two" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="0h16v16H0z"/><path d="M.5.5h6v6h-6zM9.5.5h6v6h-6zM.5 9.5h6v6h-6zM9.5 9.5h6v6h-6z" /></svg></template>